import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CenterTop from '@/components/layout/CenterTop.vue';
import Footer from '@/components/layout/Footer.vue';
import store from '@/store';
import GridItem from '@/components/layout/GridItem.vue';
import { router } from "@/router";
import GridLayout from '@/components/layout/GridLayout.vue';
import Separator from '@/components/layout/Separator.vue';
import { SETTINGS_LIST, SLIDEDECK_BACKGROUND } from '@/store/actions/platforms';
import SettingItem from '@/components/platform/SettingItem.vue';
import ColorPickerBoard from '@/components/color-picker/ColorPickerBoard.vue';
import SlideDeckBackgroundItem from '@/components/platform/SlideDeckBackgroundItem.vue';
import { SettingKey } from '@/store/enums/settingKeyEnum';
var SettingsPlatform = /*#__PURE__*/function (_Vue) {
  function SettingsPlatform() {
    var _this;
    _classCallCheck(this, SettingsPlatform);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SettingsPlatform, [].concat(args));
    _defineProperty(_this, "platformID", void 0);
    _defineProperty(_this, "loading", true);
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(SettingsPlatform, _Vue);
  return _createClass(SettingsPlatform, [{
    key: "workflowKey",
    get: function get() {
      return SettingKey.WORKFLOW_ENABLED;
    }
  }, {
    key: "transcriptKey",
    get: function get() {
      return SettingKey.TRANSCRIPT_ENABLED;
    }
  }, {
    key: "userSearchKey",
    get: function get() {
      return SettingKey.USER_SEARCH_ENGINE;
    }
  }, {
    key: "subtitleAutoDisplayKey",
    get: function get() {
      return SettingKey.SUBTITLE_AUTO_DISPLAY_IN_VIDEO;
    }
  }, {
    key: "videoDownload",
    get: function get() {
      return SettingKey.VIDEO_DOWNLOAD_ENABLED;
    }
  }, {
    key: "pdfDownload",
    get: function get() {
      return SettingKey.PDF_DOWNLOAD_ENABLED;
    }
  }, {
    key: "autoNextKey",
    get: function get() {
      return SettingKey.AUTO_NEXT_SECTION;
    }
  }, {
    key: "defaultSDKey",
    get: function get() {
      return SettingKey.VIDEO_DEFAULT_SD;
    }
  }, {
    key: "workflowMandatoryKey",
    get: function get() {
      return SettingKey.WORKFLOW_MANDATORY;
    }
  }, {
    key: "publishAdminKey",
    get: function get() {
      return SettingKey.ALLOW_PUBLISH_PUBLICATION;
    }
  }, {
    key: "whatchAnonymousKey",
    get: function get() {
      return SettingKey.ALLOW_ANONYMOUS;
    }
  }, {
    key: "allowCreateAccountKey",
    get: function get() {
      return SettingKey.ALLOW_ACCOUNT_CREATION;
    }
  }, {
    key: "allowSearchEngineKey",
    get: function get() {
      return SettingKey.SEARCH_ENGINE_INDEXATION;
    }
  }, {
    key: "newUserIsFormateurKey",
    get: function get() {
      return SettingKey.NEW_USER_IS_FORMATEUR;
    }
  }, {
    key: "searchContentKey",
    get: function get() {
      return SettingKey.INDEX_ALL_CONTENT;
    }
  }, {
    key: "commentEnabledKey",
    get: function get() {
      return SettingKey.COMMENT_ENABLED;
    }
  }, {
    key: "supportBubbleEnabled",
    get: function get() {
      return SettingKey.SUPPORT_BUBBLE;
    }
  }, {
    key: "activatePartageKey",
    get: function get() {
      return SettingKey.ACTIVATE_PARTAGE;
    }
  }, {
    key: "slideDeckSettingReady",
    get: function get() {
      return store.getters.settings(this.platformID) !== undefined;
    }
  }, {
    key: "platform",
    get: function get() {
      var platform = store.getters.platform(this.platformID);
      if (platform === undefined) {
        router.push('/');
      } else {
        return platform;
      }
    }
  }, {
    key: "slideDeckSetting",
    get: function get() {
      var SDsetting = store.getters.slideDeckSetting(this.platformID);
      return SDsetting;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.isSettingAvailable) {
        this.loadSettingForPlatform();
      }
    }
  }, {
    key: "slideDeckBackground",
    value: function slideDeckBackground(position) {
      var SDsetting = this.slideDeckSetting;
      if (SDsetting === undefined) {
        return undefined;
      }
      var sdBackground;
      SDsetting.slideDeckBackground.forEach(function (element) {
        if (position === element.position) {
          sdBackground = element;
        }
      });
      return sdBackground;
    }
  }, {
    key: "loadSettingForPlatform",
    value: function loadSettingForPlatform() {
      var _this2 = this;
      this.errorMsg = '';
      this.loading = true;
      store.dispatch(SETTINGS_LIST, this.platform).then(function () {
        store.dispatch(SLIDEDECK_BACKGROUND, _this2.platform).then(function () {
          _this2.loading = false;
          _this2.errorMsg = '';
        }).catch(function (err) {
          _this2.loading = false;
          _this2.errorMsg = err;
        });
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "isSettingAvailable",
    get: function get() {
      return store.getters.isPlatformSettingsAvailable;
    }
  }]);
}(Vue);
__decorate([Prop()], SettingsPlatform.prototype, "platformID", void 0);
SettingsPlatform = __decorate([Options({
  components: {
    SlideDeckBackgroundItem: SlideDeckBackgroundItem,
    ColorPickerBoard: ColorPickerBoard,
    SettingItem: SettingItem,
    Separator: Separator,
    GridLayout: GridLayout,
    GridItem: GridItem,
    Footer: Footer,
    CenterTop: CenterTop,
    MainTitle: MainTitle
  }
})], SettingsPlatform);
export default SettingsPlatform;